import { ApiResponse } from "@/interfaces/api-response";
import { ClipArtCategory } from "@/interfaces/clip-art.interface";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "clip-art-categories";

const createOne = async (data: Partial<ClipArtCategory>) => {
  const response = await apiClient.post<ApiResponse<ClipArtCategory>>(
    `/${SERVICE_ENDPOINT}`,
    data,
  );
  return response.data;
};

const getMany = async (params: {
  sort?: string;
  page?: number;
  size?: number;
  search?: string;
  parentId?: string;
}) => {
  const response = await apiClient.get<ApiResponse<ClipArtCategory[]>>(
    `/${SERVICE_ENDPOINT}`,
    {
      params,
    },
  );
  return response.data;
};

const search = async (params: {
  sort?: string;
  page?: number;
  size?: number;
  search?: string;
}) => {
  const response = await apiClient.get<ApiResponse<ClipArtCategory[]>>(
    `/${SERVICE_ENDPOINT}/search`,
    {
      params,
    },
  );
  return response.data;
};

const getOneById = async (id: string) => {
  const response = await apiClient.get<ApiResponse<ClipArtCategory | null>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const updateOneById = async (
  id: string,
  data: Partial<ClipArtCategory>,
  params?: object,
) => {
  const response = await apiClient.put<ApiResponse<ClipArtCategory>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
    { params },
  );
  return response.data;
};

const deleteOneById = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<ClipArtCategory>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const cloneOne = async (id: string, destinationId: string | null, cloneName?: string) => {
  const response = await apiClient.post<ApiResponse<ClipArtCategory>>(
    `/${SERVICE_ENDPOINT}/${id}/clone`,
    { destinationId, cloneName },
  );
  return response.data;
};

const clipArtCategoryApi = {
  createOne,
  getMany,
  getOneById,
  updateOneById,
  deleteOneById,
  cloneOne,
  search,
};

export default clipArtCategoryApi;
